import { useState, useEffect } from "react";
import { getLogs } from "../api/common/commonApi";
import { errorStatusHandle } from "../utils/error-utils";
import { getUrlHasPagination } from "../utils/url-utils";
import {
  clearComponentLoading,
  setAlertSuccess,
  setComponentLoading,
  setHistorySearchAlertError,
  clearButtonProcessing,
  setButtonProcessing
} from "../store/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

const useGetLogs = (reload, getUrl, loadingPage, buttonId = '') => {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [dataSearch, SetDataSearch] = useState({
    username: "",
    name: "",
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    dispatch(setComponentLoading(loadingPage));
    if (reload && !_.isEmpty(buttonId)) {
      dispatch(setButtonProcessing(buttonId));
    }
    getLogs(getUrlHasPagination(dataSearch, page, perPage, getUrl))
      .then((response) => {
        setLogs(response.data.logs);
        setTotalCount(response.data.pagination.total_count);
        setTotalPages(response.data.pagination.total_pages);
        dispatch(setAlertSuccess(response.message));
      })
      .catch((error) => {
        setLogs([]);
        setTotalCount(0);
        errorStatusHandle(error);
        if (error.status === 400) {
          let response = error.data;
          dispatch(setHistorySearchAlertError(response));
          if (!_.isEmpty(response.errors)) {
            setErrors(response.errors);
          }
        }
      })
      .finally(() => {
        dispatch(clearComponentLoading(loadingPage));
        if (reload && !_.isEmpty(buttonId)) {
          dispatch(clearButtonProcessing(buttonId));
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, perPage, reload]);

  return {
    errors,
    logs,
    page,
    perPage,
    totalCount,
    totalPages,
    dataSearch,
    setErrors,
    setLogs,
    setPage,
    setPerPage,
    setTotalCount,
    setTotalPages,
    SetDataSearch,
  };
};

export default useGetLogs;
